<template>
  <span class="employee-thumbnail">
    <span v-if="type === 'select'">
      <div v-if="employee.gender === 'Jongen' || employee.gender === 'M'" :class="getSelectedClass(selected)" class="thumbnail" :style="{background: 'url(' + require('@/assets/placeholder-boy.png') + ')'}">
      </div>
      <div v-else-if="employee.gender === 'Meisje' || employee.gender === 'V'" :class="getSelectedClass(selected)" class="thumbnail" :style="{background: 'url(' + require('@/assets/placeholder-girl.png') + ')'}">
      </div>
      <div v-else :class="getSelectedClass(selected)" class="thumbnail" :style="{background: 'url(' + require('@/assets/placeholder-girl.png') + ')'}">
      </div>
    </span>
    <span style="display:block" v-else>
      <div v-if="employee.gender === 'Jongen' || employee.gender === 'M'" :class="getPresenceClass(employee.presence)" class="thumbnail" :style="{background: 'url(' + require('@/assets/placeholder-boy.png') + ')'}">
      </div>
      <div v-else-if="employee.gender === 'Meisje' || employee.gender === 'V'" :class="getPresenceClass(employee.presence)" class="thumbnail" :style="{background: 'url(' + require('@/assets/placeholder-girl.png') + ')'}">
      </div>
      <div v-else :class="getPresenceClass(employee.presence)" class="thumbnail" :style="{background: 'url(' + require('@/assets/placeholder-girl.png') + ')'}">
      </div>
    </span>
  </span>
</template>

<script>
export default {
  name: 'employee-thumbnail',
  props: ['employee', 'type', 'selected', 'height'],
  data () {
    return {
      photo: null
    }
  },
  methods: {
    getSelectedClass (selected) {
      if (selected === true) {
        return 'selected'
      } else {
        return 'not-selected'
      }
    },
    getPresenceClass (employeePresence) {
      if (employeePresence.present === true) {
        return 'present'
      } else {
        return 'not-present'
      }
    }
  }
}
</script>

<style scoped>
  img {
    width: 100%;
    margin: 0;
    margin-top: 2px;
  }
  .present {
    border: 2px solid #48C88D;
  }
  .not-present {
    border: 2px solid #FF594F;
  }
  .selected {
    border: 3px solid #6ac8f2;
  }
  .not-selected {
    border: 3px solid #dedee7;
  }
  .employee-thumbnail {
    position: relative;
    top: 0;
    left: 0;
    width: 65px;
  }
  .thumbnail {
    position: relative;
    top: 0;
    left: 0;
    width: 65px;
    height: 65px;
    border-radius: 50%;
    background-repeat: no-repeat !important;
    background-attachment: fixed;
    background-position: center; 
    background-size: cover !important;
  }
</style>
